/**
 * Created by yinqf on 2018/6/5.
 * http配置
 */
import axios from 'axios';
import router from '../router';
import qs from 'querystring';
import config from '../config';
import { Toast } from 'vant';
import { Dialog } from 'vant';

// axios 配置
axios.defaults.timeout = 20000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = config.apiUrl;
axios.defaults.transformRequest = function(data) {
  return qs.stringify(data);
};

// http request 拦截器
axios.interceptors.request.use(
    config => {
      if (window.localStorage.getItem('token')) {
        config.headers.common['access_token'] = window.localStorage.getItem('token');
      }
      return config;
    },
    err => {
      return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
      if (response.data && response.data.errorType) {
        if (Object.is(response.data.errorType, 'token_expire')) {
          // 超时TOKEN，跳到登录页面
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          });
        } else if (Object.is(response.data.errorType, 'token_invalid')) {
          // 无效TOKEN，跳到登录页面
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          });
        } else if (Object.is(response.data.errorType, 'token_down_line')) {
          // 强制下线，跳到登录页面
          Dialog.alert({
            message: '您的账号已在另一设备登录.'
          }).then(() => {
            router.replace({
              path: '/login',
              query: { redirect: router.currentRoute.fullPath }
            });
          });
        }
      }
      return response;
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 401 跳转到登录页面
            router.replace({
              path: '/login',
              query: { redirect: router.currentRoute.fullPath }
            });
        }
      }
      if (error.message.indexOf('timeout') !== -1) {
        Toast.clear();
        Toast.fail('请求超时.');
      } else if (error.message.indexOf('Network Error') !== -1) {
        Toast.clear();
        Toast.fail('网络连接失败.');
      }
      return Promise.reject(error);
    });

export default axios;
